import React from 'react';
import { Segment } from 'semantic-ui-react';
import './PointingSegment.css';
export var PointingSegment = function (_a) {
    var children = _a.children;
    return (React.createElement(Segment, { raised: true, className: "pointing-segment left pointing label" }, children));
    // alternative approach
    // return <div className="pointing-segment pointing-label-right-side">{children}</div>
};
//# sourceMappingURL=PointingSegment.js.map